var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","position":"relative"}},[_c('a',{attrs:{"href":!_vm.noClick ?  "/ideen?kategorie=" + _vm.category + "&startMap=true&startLat=" + _vm.lat + "&startLng=" + _vm.lng : "https://www.google.de/maps"}},[(_vm.disabled || (this.lat == null && this.lng == null))?_c('div',{staticClass:"map-overlay"}):_vm._e(),_vm._v(" "),_c('GmapMap',{style:(_vm.show
          ? 'width: 250px; height: 250px; border-radius: 6px'
          : 'width: 100%; height: 100%; border-radius: 6px'),attrs:{"center":{ lat: _vm.latDefault, lng: _vm.lngDefault },"zoom":_vm.zoomLevel,"options":{
        styles: _vm.myStyle,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
      }}},[(!_vm.neutral && this.lat != null && this.lng != null)?_c('gmap-custom-marker',{attrs:{"marker":{
          lat: _vm.latDefault,
          lng: _vm.lngDefault,
        }}},[_c('img',{attrs:{"src":"/map-marker.svg"}})]):_vm._e()],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }